import FormControlLabel from "@material-ui/core/FormControlLabel"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import React, { Component } from "react"

interface Props {
  showAnswer: boolean
  submissionAnswer?: string
  onAnswerChange: (stagedAnswer: string) => void
}

interface State {
  stagedAnswer: string
}

class TrueFalseQuestion extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      stagedAnswer: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidUpdate({ showAnswer: prevShowAnswer }: Props) {
    if (this.props.showAnswer && !prevShowAnswer) {
      this.setState({ stagedAnswer: "" })
    }
  }

  handleChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ stagedAnswer: value }, () =>
      this.props.onAnswerChange(value)
    )
  }

  render() {
    const disabled = Boolean(this.props.showAnswer)
    const value = disabled
      ? this.props.submissionAnswer
      : this.state.stagedAnswer
    return (
      <RadioGroup value={value} onChange={this.handleChange} row>
        <FormControlLabel
          disabled={disabled}
          value="true"
          control={<Radio color="primary" />}
          label="True"
          labelPlacement="end"
        />
        <FormControlLabel
          disabled={disabled}
          value="false"
          control={<Radio color="primary" />}
          label="False"
          labelPlacement="end"
        />
      </RadioGroup>
    )
  }
}

export default TrueFalseQuestion
